import React, { PropTypes } from 'react/addons';
import cx from 'classnames';

import Icon from 'ofs/components/common/Icon';

const Arrow = React.createClass({
  propTypes: {
    disabled: React.PropTypes.bool,
    direction: PropTypes.oneOf(['next', 'previous']),
    onClick: PropTypes.func,
  },

  render() {
    var { disabled, direction, onClick } = this.props;

    const arrowClasses = cx({
      'ofs-Calendar__Arrow': true,
      'ofs-Calendar__Arrow--previous': direction === 'previous',
      'ofs-Calendar__Arrow--next': direction === 'next',
      'ofs-Calendar__Arrow--is-disabled': disabled,
    });

    const arrowIconClasses = cx({
      'ofs-Calendar__ArrowIcon': true,
      'ofs-Calendar__ArrowIcon--is-disabled': disabled,
    });

    return (
      <div className={arrowClasses} onClick={onClick}>
        <div className={arrowIconClasses}>
          <Icon glyph="arrow" size="small" variant={direction === 'previous' ? 'left' : 'right'} />
        </div>
      </div>
    );
  }
});

export default Arrow;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/Calendar/Arrow.jsx
 **/